// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3KrMZ","retryBtn":"styles_retryBtn__Udciz","retryBtnIcon":"styles_retryBtnIcon__mti-e"};